import React from 'react';
import {  ILesson } from '@beable/roster-backend-client-v1';
import isEmpty from 'lodash/isEmpty';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { range } from 'lodash';
import { getStyles } from './styles';

type CourseDetailsCourse = {
courseId: string;
sort?: number;
courseName?: string;
grades?: string[];
parentName?: string;
locationCode?: string;
};

interface ContentCourseDetailsProps {
  course:  CourseDetailsCourse;
  className?: string;
  lessons?: ILesson[];
  sort?: number | undefined;
}

export default function ContentCourseDetails({ className, course, lessons =[], sort }: ContentCourseDetailsProps){
  const theme = useTheme();
  const styles = getStyles(theme);
  const location = courseLocation(course);

  const formatGrades = (grades: string[]) => {
    const useGrades = grades.map((g) => Number(g)).sort((a, b) => a - b);

    const low = useGrades[0];
    const high = useGrades[grades.length-1];
    const gradeRange = range(Number(low), Number(high)+1);

    if (gradeRange.join(',') === useGrades.join(',')) {
      return (low === high) ? low : `${low}-${high}`;
    }
    return useGrades.join(',');
  };

  const courseTitle = () => {
    if (course.sort || sort) {
      return (course.sort || sort) + '. ' + course.courseName;
    }
    return course.courseName;
  }

    return (
      <Box component="div" className={className} sx={styles.pCourseOptionsContainer}>
        <p><Box component="span" sx={styles.pCourseOptionsTitle}>{courseTitle()}</Box>
          { !isEmpty(lessons) && (<Box component="span" sx={styles.pCourseOptionsSubtitle}><br />{`${lessons.length} lesson(s)`}</Box>) }</p>
        <Box component="div" sx={styles.pCourseOptionsDetails}>

        {course.grades && <><b>Grades: </b>
          <span>{formatGrades(course.grades)}</span>, </>}
          {location && <>
          <b>Location: </b>
          <span>
            {courseLocation(course)}
          </span>
          , {course.parentName ? <b>Child of Parent: </b> : <b>Parent</b>}
          <span>{course.parentName ? course.parentName : ''}</span>
          </>}
        </Box>
      </Box>
    );
  }

  export const courseLocation = (course: CourseDetailsCourse)=>course.parentName && !isEmpty(course.locationCode)
  ? course.locationCode
  : 'All';